import { pick as _pick } from 'es-toolkit/compat';
import { map as _map } from 'es-toolkit/compat';
import { VARIABLE_UPDATE_TYPE } from '../constants';

const checkVariableUpdateType = (
  modifiedRow: Record<string, any>[],
  columnId: string,
) => {
  let variableUpdateType =
    'variableUpdateType' in modifiedRow
      ? modifiedRow['variableUpdateType']
      : undefined;

  if (
    columnId === 'key' &&
    (variableUpdateType === undefined ||
      variableUpdateType === VARIABLE_UPDATE_TYPE.RESET)
  ) {
    variableUpdateType = VARIABLE_UPDATE_TYPE.KEY;
  } else if (columnId === 'key' && variableUpdateType !== 'key') {
    variableUpdateType = VARIABLE_UPDATE_TYPE.ALL;
  }

  if (
    columnId === 'value' &&
    (variableUpdateType === undefined ||
      variableUpdateType === VARIABLE_UPDATE_TYPE.RESET)
  ) {
    variableUpdateType = VARIABLE_UPDATE_TYPE.VALUE;
  } else if (columnId === 'value' && variableUpdateType !== 'value') {
    variableUpdateType = VARIABLE_UPDATE_TYPE.ALL;
  }
  return variableUpdateType;
};

const createPayload = (variables) =>
  variables?.reduce((acc, item) => {
    const { isEdited, isTempEncrypted, isEncrypted } = item;

    if (isEdited)
      acc.push({
        ..._pick(item, [
          'id',
          'key',
          'value',
          'projectId',
          'markAsDeleted',
          'variableUpdateType',
        ]),
        isEncrypted: isTempEncrypted ? true : isEncrypted,
      });

    return acc;
  }, []);

const sanitizeResponse = (res) =>
  _map(res, (item) => ({
    ...item,
    isEdited: false,
    isTempEncrypted: false,
    canShowEncryptValue: false,
    isEncrypted: item?.hasOwnProperty('encrypted')
      ? item.encrypted
      : item.isEncrypted,
    markAsDeleted: false,
    isCloned: false,
  }));

const filterVariablesByKey = (variables, key) =>
  variables.filter((item) => !!item[key]);

const getClonedVariablesCount = (variables, value) =>
  variables.filter((item) => item.isCloned && item.value == value).length;

const getInputType = ({ isEncrypted, isTempEncrypted, canShowEncryptValue }) =>
  isEncrypted || (isTempEncrypted && !canShowEncryptValue)
    ? 'password'
    : 'text';

export {
  createPayload,
  sanitizeResponse,
  filterVariablesByKey,
  getClonedVariablesCount,
  getInputType,
  checkVariableUpdateType,
};
